module.exports = __webpack_public_path__ + "img/logo.96a9cf14.svg";